
import Dropdown from 'components/common/Dropdown/Dropdown';

import styles from './SortingOptions.scss';

export const SortingOptions = ({children}) => {

    return (
        <div className={styles.sortingOptionsPanel}>
            { children }
        </div>
    );
};

export const SortingOption = (props) => {
    return (
        <div className={styles.sortingOptionsBlock} data-cy="SortingOption">
            <Dropdown {...props} />
        </div>
    );
};
